// extracted by mini-css-extract-plugin
module.exports = {"bookPage":"Reader_bookPage__1X98Y","main":"Reader_main__mfa2Z","focusMode":"Reader_focusMode__6mDtH"};